/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import React, { useState } from 'react';
import PreferenceStepDisplay from './PreferenceStepDisplay';

const PreferenceStep = ({
  initialValues = {},
  stepOneFormValues,
  onCancel,
  onStepCompleted,
  isSaving,
}) => {
  const [formValues, setFormValues] = useState({
    ...initialValues,
  });

  const onChange = (event) => {
    const { name, value } = event.target;
    const updatedFormValues = { ...formValues, [name]: value };
    setFormValues(updatedFormValues);
  };

  const onNextClick = () => {
    onStepCompleted(formValues);
  };

  return (
    <PreferenceStepDisplay
      formValues={formValues}
      stepOneFormValues={stepOneFormValues}
      onChange={onChange}
      onNextClick={onNextClick}
      onCancel={onCancel}
      isSaving={isSaving}
    />
  );
};

export default PreferenceStep;
